import React, { useState, useEffect, useRef, useMemo, useContext } from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import CancelIcon from "@mui/icons-material/Close";
import Container from "@mui/material/Container";
import Button from "@mui/material/Button";
import SearchIcon from "@mui/icons-material/Search";
import Drawer from "@mui/material/Drawer";
import { useNavigate } from "react-router-dom";
import { styles, useStyles, Search, drawerWidth } from "./headerStyle";
import { v4 } from "uuid";
import { getHeaderDetails } from "./requestCall";
import { SubNav } from "./SubNav";
import DrawerComp from "./DrawerComp";
import MeiliSearch from "meilisearch";
import useDebounce from "../../utils/debounceHook";
import MyContext from "../context/MyContext";
import { useMediaQuery } from "@mui/material";
import { MOBLIE_VIEW_WIDTH } from "../../constants/constants";

const Header = (props) => {
  const { tabValue, setTabValue, setCarModel } = useContext(MyContext);
  const [responseData, setResponseData] = useState();
  const [logoDetails, setLogoDetails] = useState();
  const [mobileOpen, setMobileOpen] = useState(false);
  const [borderTabValue, setBorderTabValue] = useState(null);
  const [searchIconClicked, setSearchIconClicked] = useState(false);

  const [collection, setCollection] = React.useState([]);
  const [searchTerm, setSearchTerm] = React.useState("");
  const debouncedSearchTerm = useDebounce(searchTerm, 1000);
  const matches = useMediaQuery(MOBLIE_VIEW_WIDTH);

  const fetchMeiliSearchData = async () => {
    const client = new MeiliSearch({});
    const index = await client.getIndex("dtindex");
    const movies = await index.search(debouncedSearchTerm);
    setCollection(movies.hits.slice(0, 5));
  };

  const navigate = useNavigate();

  const handleClose = () => {
    setBorderTabValue(null);
  };
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const container =
    props.window !== undefined ? () => props.window().document.body : undefined;

  useEffect(() => {
    getHeaderDetails().then(({ data }) => {
      const headData = data.menu.items;
      const homeIndex = headData.findIndex(
        (d) => d?.dataAttribute?.toLowerCase() === "home"
      );
      const logoData = headData.splice(homeIndex, 1);
      setLogoDetails(logoData[0]);
      setResponseData(headData);
      setCarModel(headData.filter((i) => i.id === 2));
    });
  }, []);

  useEffect(() => {
    setSearchIconClicked(false);
  }, [borderTabValue]);

  const buttonRef = useRef();

  const classes = useStyles();

  const subNavArrayMemo = useMemo(() => {
    const subNavArray = [];

    responseData?.forEach((d) => {
      if (d.children.length > 0) {
        subNavArray.push(d.dataAttribute);
      }
    });
    return subNavArray;
  }, [responseData]);

  const handleNavHover = (tabValue) => {
    setBorderTabValue(tabValue);
    setTabValue(tabValue);
  };

  const handleNavClick = (tabValue, target) => {
    setTabValue(tabValue);
    responseData.forEach((data) => {
      if (
        tabValue === data.dataAttribute &&
        !(subNavArrayMemo || []).includes(tabValue)
      ) {
        target === "_blank"
          ? window.open(data.url, "_blank")
          : navigate(data.url);
        handleDrawerToggle();
      }
    });
  };

  return (
    responseData && (
      <Box sx={{ position: "fixed", width: "100%", zIndex: 11 }}>
        <AppBar
          position="static"
          sx={matches ? { ...styles.container } : { ...styles.containerMobile }}
        >
          <Container maxWidth="xl">
            <Toolbar disableGutters>
              <Box
                component="img"
                sx={{
                  maxHeight: "64px",
                  width: "auto",
                  maxWidth: "362px",
                  display: { xs: "none", md: "flex" },
                  cursor: "pointer",
                }}
                src={`${process.env.REACT_APP_BASEURL}${logoDetails?.thumbnailImage?.url}`}
                alt="logo"
                onClick={() => navigate(logoDetails?.url)}
              />

              <Box
                sx={{
                  flexGrow: 1,
                  display: {
                    xs: "flex",
                    md: "none",
                    justifyContent: "space-between",
                  },
                }}
              >
                <Box
                  component="img"
                  sx={{
                    width: "100%",
                    maxWidth: "226.25px",
                    display: { xs: "inline-block", md: "none" },
                    cursor: "pointer",
                    padding: `${!matches ? "5px 0" : "12px 0"}`,
                  }}
                  src={
                    process.env.REACT_APP_BASEURL +
                    logoDetails?.thumbnailImage?.url
                  }
                  alt="logo"
                  onClick={() => navigate(logoDetails?.url)}
                />

                <IconButton
                  size="large"
                  aria-label="account of current user"
                  aria-controls="menu-appbar"
                  aria-haspopup="true"
                  onClick={handleDrawerToggle}
                  color="inherit"
                  sx={{ display: { justifyContent: "right" } }}
                >
                  <MenuIcon />
                </IconButton>
              </Box>

              <Box
                sx={{
                  flexGrow: 1,
                  display: {
                    xs: "none",
                    md: "flex",
                    justifyContent: "center",
                    height: "110px",
                  },
                }}
                ref={buttonRef}
              >
                {responseData.map((page) => (
                  <Box key={v4()} sx={{ marginRight: "4%" }}>
                    <Button
                      key={v4()}
                      onMouseOver={() => handleNavHover(page.dataAttribute)}
                      onClick={() =>
                        handleNavClick(page.dataAttribute, page.target)
                      }
                      sx={{
                        borderBottom:
                          page.dataAttribute?.toLowerCase() === tabValue
                            ? "3px solid #007aff"
                            : "3px solid transparent",
                        ...styles.button,
                        ...styles.genericHeaderStyling,
                      }}
                      id={page.title}
                    >
                      <span> {page.title} </span>
                    </Button>
                  </Box>
                ))}
              </Box>

              <Search
                onClick={() => setSearchIconClicked(!searchIconClicked)}
                sx={{
                  display: {
                    xs: "none",
                    md: "flex",
                    position: "relative",
                    top: "11px",
                  },
                  cursor: "pointer",
                  color: searchIconClicked ? "#007aff" : "white",
                }}
              >
                <SearchIcon />
              </Search>
            </Toolbar>
          </Container>
        </AppBar>

        <Box component="nav" sx={{ display: { xs: "block", md: "none" } }}>
          <Drawer
            container={container}
            variant="temporary"
            open={mobileOpen}
            //onClose={handleDrawerToggle}
            ModalProps={{
              keepMounted: true, // Better open performance on mobile.
            }}
            sx={{
              display: { xs: "block", md: "none" },
              "& .MuiDrawer-paper": {
                boxSizing: "border-box",
                width: drawerWidth,
              },
            }}
          >
            <DrawerComp
              responseData={responseData}
              tabValue={tabValue || responseData[0]?.dataAttribute}
              handleNavHover={handleNavHover}
              handleNavClick={handleNavClick}
              classes={classes}
              v4={v4}
              handleDrawerToggle={handleDrawerToggle}
              CancelIcon={CancelIcon}
              borderTabValue={borderTabValue || responseData[0]?.dataAttribute}
              collection={collection}
              setSearchTerm={setSearchTerm}
              debouncedSearchTerm={debouncedSearchTerm}
              fetchMeiliSearchData={fetchMeiliSearchData}
              setCollection={setCollection}
              searchTerm={searchTerm}
              navigate={navigate}
            />
          </Drawer>
        </Box>

        {((subNavArrayMemo || []).includes(borderTabValue) ||
          searchIconClicked) && (
          <SubNav
            borderTabValue={borderTabValue}
            classes={classes}
            v4={v4}
            handleClose={handleClose}
            responseData={responseData}
            collection={collection}
            setSearchTerm={setSearchTerm}
            debouncedSearchTerm={debouncedSearchTerm}
            searchIconClicked={searchIconClicked}
            setSearchIconClicked={setSearchIconClicked}
            fetchMeiliSearchData={fetchMeiliSearchData}
            setCollection={setCollection}
            navigate={navigate}
            searchTerm={searchTerm}
          />
        )}
      </Box>
    )
  );
};
export default Header;
